module.exports = __webpack_public_path__ + "static/media/Step 5-Storage_Length_Stone_Void.3988dba8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/media/tutorial-images/Step 5-Storage_Length_Stone_Void.gif
// module id = 3045
// module chunks = 0